import { TranslateModuleConfig } from '@ngx-translate/core';
import { CUSTOM_LOADER } from './custom-loader';

export const config: TranslateModuleConfig = {
	loader: CUSTOM_LOADER,
	useDefaultLang: true,
};
